import { useState } from 'react'
import { useAppBridge } from '@shopify/app-bridge-react'
import request from '../../lib/request'

const defaultState = {
  loaded: false,
  data: [],
  list: [],
  total: 0,
  searchParam: '',
  status: [],
  statusParam: [],
  sortParams: {
    field: 'createdAt',
    order: 'desc'
  },
  appExtension: {
    loaded: true,
    uuid: ''
  },
  showUpsell: false,
  redirectOnResume: null
}

export function useTestsAB() {
  const [state, setState] = useState(defaultState)
  const app = useAppBridge()

  function changeState(params) {
    setState({ ...state, ...params })
  }

  const setSearchParam = async (searchParam) => {
    changeState({ searchParam })
    await getTests(1, searchParam, state.sortParams, state.statusParam)
  }

  const setStatusParam = async (statusParam) => {
    changeState({ statusParam })
    await getTests(1, state.searchParam, state.sortParams, statusParam)
  }

  const setSortParams = async (sortParams) => {
    changeState({ sortParams })
    await getTests(1, state.searchParam, sortParams, state.statusParam)
  }

  const setShowUpsell = (showUpsell) => {
    changeState({ showUpsell })
  }

  const getTests = async (page = 1, searchParam, sort = { field: 'name', order: 'asc' }, statusParam = '') => {
    try {
      changeState({ loaded: false })
      let { list, total, app_extension } = await request(
        `test?page=${page}&searchText=${searchParam}&sort_field=${sort.field}&sort_order=${sort.order}&status=${statusParam}`,
        'GET', undefined, undefined, app
      )
      list = enrichDataForDashboard(list)
      changeState({
        loaded: true, list, data: list, appExtension: app_extension, total, searchParam, sortParams: sort, statusParam
      })
    } catch (error) {
      setState({ ...defaultState, loaded: true, list: [] })
    }
  }

  function enrichDataForDashboard(list) {
    return list.map(enrichData)

    function enrichData(test) {
      return { ...test,
        product_title: productTitle(),
        time: time(),
        type: type(),
      }

      function time() {
        return new Date(test.finish_date) - new Date()
      }

      function productTitle() {
        if (isProductAttribute()) return test.test_a.title
        if (isBulkParent()) return test.name
        if (isContentTest()) return test.name
      }

      function type() {
        if (isProductAttribute()) return '1 product'
        if (isBulkParent()) return 'Bulk'
        if (isContentTest()) return 'Content'
      }

      function isBulkParent() {
        return test.testType === 'bulk_parent'
      }

      function isProductAttribute() {
        return test.testType === 'product_attribute'
      }

      function isContentTest() {
        return test.testType === 'content'
      }
    }

  }

  const deleteTest = async (id, page = 1) => {
    try {
      // setState({ ...state, loaded: false })
      await request('test/' + id, 'DELETE', undefined, undefined, app)
      await getTests(page, state.searchParam, state.sortParams, state.statusParam)
      // const list = state.list.filter(_i => _i._id !== id)
      // const data = state.data.filter(_i => _i._id !== id)

      // changeState({
      //   loaded: true, list, data,
      // })
    } catch (error) {
      setState({ ...state, loaded: true })
    }
  }

  const deleteContentTest = async (id, page = 1) => {
    try {
      // setState({ ...state, loaded: false })
      await request('content_test/' + id, 'DELETE', undefined, undefined, app)
      await getTests(page, state.searchParam, state.sortParams, state.statusParam)
      // const list = state.list.filter(_i => _i._id !== id)
      // const data = state.data.filter(_i => _i._id !== id)

      // changeState({
      //   loaded: true, list, data,
      // })
    } catch (error) {
      setState({ ...state, loaded: true })
    }
  }

  const changeContentTestStatus = async (id, status) => {
    try {
      setState({ ...state, loaded: false })
      await request(`content_test/${id}/change_status/${status}`, 'POST', undefined, undefined, app)

      const list = state.list.map(item => {
        if (item._id !== id) return item

        return { ...item, status: status }
      })

      const data = state.data.map(item => {
        if (item._id !== id) return item

        return { ...item, status: status }
      })

      changeState({
        loaded: true, list, data,
      })
    } catch (error) {
      setState({ ...state, loaded: true })
    }
  }

  const winnerTest = async ({ id, winner }) => {
    try {
      setState({ ...state, loaded: false })
      const data = await request(`test/${id}/winner/${winner}`, 'post', {}, undefined, app)
      const list = state.list.map(item => item._id === id ? { ...item, ...data } : { ...item })
      setState({ ...state, loaded: true, list })
    } catch (error) {
      setState({ ...state, loaded: true })
    }
  }

  const pauseTest = async (id, body) => {
    try {
      setState({ ...state, loaded: false })
      const data = await request('test/pause/' + id, 'post', body, undefined, app)
      const list = state.list.map(item => item._id === id ? { ...item, ...data } : { ...item })
      setState({ ...state, loaded: true, list })
    } catch (error) {
      setState({ ...state, loaded: true })
    }
  }
  const shopReachedFreePlanLimitation = async (id) => {
    try {
      setState({ ...state, loaded: false })
      //To Do refactor: remove id
      const { reached } = await request('test/' + id + '/reached_free_plan_limitation', 'get', undefined, undefined, app)
      return reached
    } catch (error) {}
  }

  const reachedImpressionsLimit = (shop) => {
    if (shop?.pricingPlanData?.impressionLimit < 0)
      return false

    if (shop?.currentMonthImpressions < shop?.pricingPlanData?.impressionLimit )
      return false

    return true
  }

  const resumeTestWithPlanCheck = async (id) => {
    const shop = await request('default/shop', 'GET', null, undefined, app)
    const reached_impressions_limit = reachedImpressionsLimit(shop)

    if (await shopReachedFreePlanLimitation(id) || reached_impressions_limit) {
      setShowUpsell(true)
    }
    else {
      resumeTest(id)
    }
  }

  const resumeBulkTestWithPlanCheck = async (id) => {
    const shop = await request('default/shop', 'GET', null, undefined, app)
    const reached_impressions_limit = reachedImpressionsLimit(shop)
    if (await shopReachedFreePlanLimitation(id) || reached_impressions_limit ) {
      setShowUpsell(true)
    }
    else {
      resumeBulkTest(id)
    }
  }

  const resumeTest = async (id) => {
    try {
      setState({ ...state, loaded: false })
      const data = await request('test/resume/' + id, 'post', undefined, undefined, app)
      const list = state.list.map(item => item._id === id ? { ...item, ...data } : { ...item })
      setState({ ...state, loaded: true, list })
    } catch (error) {
      setState({ ...state, loaded: true })
    }
  }

  const resumeBulkTest = async (id) => {
    try {
      setState({ ...state, loaded: false })
      const data = await request('bulk_test/resume/' + id, 'post', undefined, undefined, app)
      const list = state.list.map(item => item._id === id ? { ...item, ...data } : { ...item })
      setState({ ...state, loaded: true, list })
    } catch (error) {
      setState({ ...state, loaded: true })
    }
  }

  const deleteBulkTest = async (id, page = 1) => {
    try {
      // setState({ ...state, loaded: false })
      await request('bulk_test/delete/' + id, 'post', undefined, undefined, app)
      await getTests(page, state.searchParam, state.sortParams, state.statusParam)
      // const list = state.list.filter(_i => _i._id !== id)
      // const data = state.data.filter(_i => _i._id !== id)
      // changeState({
      //   loaded: true, list, data,
      // })

    } catch (error) {
      setState({ ...state, loaded: true })
    }
  }

  const pauseBulkTest = async (id) => {
    try {
      setState({ ...state, loaded: false })
      const data = await request('bulk_test/pause/' + id, 'post', undefined, undefined, app)
      const list = state.list.map(item => item._id === id ? { ...item, ...data } : { ...item })
      setState({ ...state, loaded: true, list })
    } catch (error) {
      setState({ ...state, loaded: true })
    }
  }

  const finishBulkTest = async (id) => {
    try {
      setState({ ...state, loaded: false })
      const data = await request('bulk_test/finish/' + id, 'post', undefined, undefined, app)
      const list = state.list.map(item => item._id === id ? { ...item, ...data } : { ...item })
      setState({ ...state, loaded: true, list })
    } catch (error) {
      setState({ ...state, loaded: true })
    }
  }

  const redirectOnResume = (value) => setState({ redirectOnResume: value })

  return [state, { getTests, setSearchParam, setStatusParam, setSortParams, setShowUpsell, winnerTest, pauseTest, resumeTest, deleteTest, resumeBulkTest, deleteBulkTest, pauseBulkTest, finishBulkTest, deleteContentTest, changeContentTestStatus, redirectOnResume, resumeTestWithPlanCheck, resumeBulkTestWithPlanCheck }]
}
